/** Shared between AccessSection (standalone grants) and UsersSection (grant-at-creation) --
 *  one department/site vocabulary, kept in one place so the two screens can't drift apart.
 *  Mirrors db/user_access.sql's department CHECK constraint and serving/auth.py's SITE_CODES. */
export const DEPARTMENTS = [
  { id: 'operations', label: 'Operations', hint: 'Reports, site-wise' },
  { id: 'safety', label: 'Safety', hint: 'DMS/ADAS reports, site-wise' },
  { id: 'maintenance', label: 'Maintenance', hint: 'Breakdown reports, site-wise' },
  { id: 'battery_field_team', label: 'Battery Field Team', hint: 'Alerts, site-wise' },
  { id: 'call_centre', label: 'Call Centre', hint: 'Alerts + contact info, site-wise' },
  { id: 'ground_ops', label: 'Ground Ops', hint: 'Alerts (route/depot/geofence triage), site-wise' },
  { id: 'it_support', label: 'IT-Support', hint: 'Full access (grant the admin role too)' },
  { id: 'management', label: 'Management', hint: 'Full access, automatically -- no admin role needed' },
] as const

export const DEPARTMENT_LABEL: Record<string, string> = Object.fromEntries(
  DEPARTMENTS.map((d) => [d.id, d.label]),
)

export const SITES = [
  { id: 'mbmt', label: 'MBMT' },
  { id: 'nagpur', label: 'Nagpur' },
  { id: 'ultratech', label: 'Ultratech' },
  { id: 'gti', label: 'GTI' },
  { id: 'jm_baxi', label: 'JM Baxi' },
  { id: 'star_cement', label: 'STAR Cement' },
  { id: 'tupl', label: 'TUPL' },
] as const

export function DepartmentPicker({
  value, onChange, items = DEPARTMENTS,
}: {
  value: string
  onChange: (id: string) => void
  items?: ReadonlyArray<{ id: string; label: string; hint: string }>
}) {
  return (
    <div className="grid gap-1.5">
      {items.map((d) => (
        <button
          key={d.id} type="button" onClick={() => onChange(d.id)}
          className={
            'rounded-lg border px-3 py-2 text-left transition-colors ' +
            (value === d.id ? 'border-blue-400 bg-blue-50' : 'border-slate-200 bg-white hover:bg-slate-50')
          }
        >
          <span className="block text-sm font-medium text-slate-900">{d.label}</span>
          <span className="block text-xs text-slate-500">{d.hint}</span>
        </button>
      ))}
    </div>
  )
}

export function SiteMultiSelect({ value, onChange }: { value: string[]; onChange: (sites: string[]) => void }) {
  const toggle = (id: string) =>
    onChange(value.includes(id) ? value.filter((s) => s !== id) : [...value, id])
  return (
    <div className="flex flex-wrap gap-2">
      {SITES.map((s) => (
        <button
          key={s.id} type="button" onClick={() => toggle(s.id)}
          className={
            'rounded-full border px-3 py-1 text-xs transition-colors ' +
            (value.includes(s.id)
              ? 'border-blue-400 bg-blue-50 text-blue-700'
              : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50')
          }
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
